export interface SiteInfo {
  name: string;
  slogan: string;
  intro: string;
  domain: string;
  email: string;
  wechat: string;
  foundedYear: string;
  principles: { title: string; desc: string; icon: string }[];
  stats: { value: string; label: string }[];
  testimonials: { name: string; role: string; text: string }[];
}

export const siteInfo: SiteInfo = {
  name: "51爆料网",
  slogan: "先求证，再表达",
  intro:
    "51爆料网是一个以栏目导航为入口的内容门户，聚合深度调查、实时热点、消费爆料、辟谣科普、行业观察与生活警示等内容板块。我们希望把分散的信息重新组织成清晰的查找路径，让读者在几十秒内就能定位到需要的栏目，而不是在层层跳转里消耗耐心。",
  domain: "www.51baoliao.com",
  email: "hello@51baoliao.com",
  wechat: "baoliao51",
  foundedYear: "2019",
  principles: [
    {
      title: "多方求证",
      desc: "单一信源不下结论，重要事实至少经过两处独立来源交叉比对后再呈现。",
      icon: "ri-shield-check-line",
    },
    {
      title: "可核验",
      desc: "涉及数据与条款的内容尽量给出出处或可自行查验的方式，方便读者复核。",
      icon: "ri-links-line",
    },
    {
      title: "不猎奇",
      desc: "拒绝用夸张措辞博取点击，标题与正文内容必须一致，不制造无谓的紧张感。",
      icon: "ri-emotion-normal-line",
    },
    {
      title: "有后续",
      desc: "对持续发生的事件保持跟踪，在事实变化时及时补充更新，而不是发完就不管。",
      icon: "ri-history-line",
    },
  ],
  stats: [
    { value: "8", label: "常设栏目板块" },
    { value: "1,200+", label: "累计内容条目" },
    { value: "6", label: "年持续更新" },
    { value: "每日", label: "热点与科普更新节奏" },
  ],
  testimonials: [
    {
      name: "陈先生",
      role: "长期读者",
      text: "栏目导航页帮了大忙，以前找深度调查要翻半天，现在一页就能看到所有板块入口，直接点进去就行。",
    },
    {
      name: "林女士",
      role: "消费维权关注者",
      text: "消费爆料里的处理路径写得很实在，我照着整理的思路去和商家沟通，最后真的把保价的事解决了。",
    },
    {
      name: "周同学",
      role: "高校读者",
      text: "辟谣科普会告诉你怎么自己核验，而不是简单说一句「假的」，这点比很多平台都靠谱。",
    },
  ],
};